import { create } from 'zustand';

export interface UserInfo {
  id: number | string; // Support both number and string (UUID) IDs
  userName: string;
  name: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  fullName: string;
  lastLoginTime: Date | null;
  creationTime: Date;
  roleNames: string[];
}

interface UserState {
  userInfo: UserInfo | null;
  user: UserInfo | null; // Alias for compatibility
  setUserInfo: (info: UserInfo) => void;
  clearUserInfo: () => void;
  hasRole: (role: string) => boolean;
  isTeacher: () => boolean;
  isStudent: () => boolean;
}

export const useUserStore = create<UserState>((set, get) => ({
  userInfo: null,
  user: null, // Initialize the alias

  setUserInfo: (info: UserInfo) => {
    set({ userInfo: info, user: info });
  },

  clearUserInfo: () => {
    set({ userInfo: null, user: null });
  },

  hasRole: (role: string) => {
    const { userInfo } = get();
    return userInfo?.roleNames.includes(role) || false;
  },

  isTeacher: () => {
    const { hasRole } = get();
    return hasRole('Teacher');
  },

  isStudent: () => {
    const { hasRole } = get();
    return hasRole('Student');
  },
}));